import { LoadingContainer } from 'components/Common/LoadingContainer'
import ShowToRoleAndStates from 'components/Common/Portal/ShowToRole'
import { ConfigurationController } from 'controllers/Analytics/ConfigurationController'
import { KPI } from 'controllers/Analytics/SalesLeadTimeController'
import { useController } from 'customHooks/useController'
import { useEffect, useState } from 'react'
import { useOrganizationContext } from 'utils/useOrganizationContext'
import { KPITargetConfiguration } from './DashboardWidget'
import { ConversionRateWidget } from './Widgets/ConversionRateWidget'
import { NegotiationCycleTime } from './Widgets/NegotiationCycleTimeWidget'
import { ResponseCycleTime } from './Widgets/ResponseCycleTimeWidget'
import { SalesLeadTimeWidget } from './Widgets/SalesLeadTimeWidget'

export const Dashboard = () => {
  const { organizationId, isBuyingParty } = useOrganizationContext()
  const [configurations, setConfigurations] =
    useState<KPITargetConfiguration[]>(undefined)
  const [error, setError] = useState(false)

  const { controller, loading } = useController(
    () => new ConfigurationController(organizationId)
  )

  useEffect(() => {
    ;(async () => {
      try {
        const configurations = await controller.GetAnalyticsConfigurations()
        setConfigurations(configurations)
      } catch (err) {
        // if (err['message'] === 'cancelled') return
        // ShowException('analytics', err)
        setError(true)
      }
    })()

    return () => controller.CancelRequests()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (error || !configurations?.find) return null

  return (
    <ShowToRoleAndStates seller isBuyerRole={isBuyingParty}>
      <LoadingContainer
        loading={loading['get-kpi-configurations']}
        noMessage
        style={{ height: '75%' }}
        empty={!configurations && !loading && null}
      >
        <ResponseCycleTime
          {...configurations?.find((x) => x.kpi === KPI.responseTime)}
          onError={() => setError(true)}
        />
        <NegotiationCycleTime
          {...configurations?.find((x) => x.kpi === KPI.negotiationTime)}
          onError={() => setError(true)}
        />
        <SalesLeadTimeWidget
          {...configurations?.find((x) => x.kpi === KPI.salesLeadtime)}
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          onError={(_kpi, _message) => {
            setError(true)
          }}
        />
        <ConversionRateWidget
          onError={() => setError(true)}
          {...configurations?.find((x) => x.kpi === KPI.conversionRate)}
        />
      </LoadingContainer>
    </ShowToRoleAndStates>
  )
}
